import gql from 'graphql-tag'

export const GetMappingTemplates = gql`
  query GetMappingTemplates {
  mapping_templates
}`